import { receivingConfirmRequestComponent } from './confirmRequest.component';
import { receivingStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const receivingConfirmRequestStateName = `${receivingStateName}.confirmRequest`;

export const receivingConfirmRequestState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingConfirmRequestStateName,
    url: '/request/confirm/:ticketId',
    component: receivingConfirmRequestComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket(),
      stateIndex: () => 1, // Second step for a new receiving request ticket
      skipState: (appConfig) => {
        const config = appConfig;
        return !config.ui.receivingRequest.confirm;
      },
    },
  });
};
